"use client";

import React from "react";
import type { SkeletonSpec } from "@/hooks/usePanelState";

interface SkeletonRowsProps {
  spec: SkeletonSpec;
  className?: string;
}

/**
 * Shimmer-animated skeleton rows sized to a blotter row layout. The first
 * column bar is left-aligned; remaining bars are pushed to the right edge,
 * matching the numeric right-aligned cells of the real blotter.
 */
export function SkeletonRows({ spec, className }: SkeletonRowsProps) {
  const { columnWidths, rowCount } = spec;
  return (
    <div
      className={className}
      role="status"
      aria-busy="true"
      aria-label="Loading…"
    >
      {Array.from({ length: rowCount }, (_, r) => (
        <div
          key={r}
          className="flex h-7 items-center gap-2.5 border-b border-border/40 px-3"
        >
          {columnWidths.map((w, c) => (
            <span
              key={c}
              className="vybe-skeleton-bar h-[9px]"
              style={{ width: w, marginLeft: c === 1 ? "auto" : undefined }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default SkeletonRows;
